<div class="modal auto-renewal-modal">
    <div class="model-container">
        <div class="modal-header">
            <h3 class="modal-heading" translate>auto-renew-modal.turn-off-auto-renew</h3>
            <img class="modal-close" (click)="closeDialog(false)" src="/assets/icon/primary-close.svg" alt="close-icon"
                width="28" height="28">
        </div>
        <div class="modal-body">
            <div class="contents">
                <p translate>auto-renew-modal.not-renew-automatically</p>
            </div>
            <div class="modal-actions">
                <button class="button primary" aria-label="keep auto renewal" (click)="closeDialog(false)" translate>
                    auto-renew-modal.keep-auto-renew
                </button>
                <button class="button secondary" aria-label="remove auto renewal" (click)="closeDialog(true)" translate>
                    auto-renew-modal.remove-auto-renew
                </button>
            </div>
        </div>
    </div>
</div>